namespace GeniuzPOS.ReportMasterData {
    export class Report_1201_Recv2Columns {
        static columnsKey = 'ReportMasterData.Report_1201_Recv2';
    }
}
